/** Fired by PackagingProvider when the journey will not open for a piece (no Luxe or Signature passed, Q20). */
export const PACKAGING_UNAVAILABLE_EVENT = 'PACKAGING_JOURNEY_UNAVAILABLE';
